export const C_TOAST_KEYS = {
    BOTTOM_CENTER: 'bc',
    TOP_CENTER: 'tc'
} as const;